import { render, staticRenderFns } from "./TrafficData.vue?vue&type=template&id=ce10d3f2&scoped=true"
import script from "./TrafficData.vue?vue&type=script&lang=js"
export * from "./TrafficData.vue?vue&type=script&lang=js"
import style0 from "./TrafficData.vue?vue&type=style&index=0&id=ce10d3f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce10d3f2",
  null
  
)

export default component.exports